module.exports = __webpack_public_path__ + "img/Stage_6_Diff.58c2f2dc.jpg";